import React, { useState, useRef,useEffect, useMemo } from "react";
import '../../css/elements.css';
import QuilityNestedBlock from "./quilityNestedBlock";
import { SuccessAlert } from '../successAlert';
import { useSelector, useDispatch } from 'react-redux';
import { setQueue, setBackup, setWholeQueue, setQueueSource } from '../../features/queueSlice';
import { isWithin24Hours } from "../../utilities/timeFunctions"
import { getLeadsByTimePeriod, leadTimePeriodsFilterOptions } from "../../utilities/leadFunctions";
import { hashify, isObjectEmpty, quilityParentBlockType } from "../../utilities/genericUtils";
import { useDebouncedCallback } from 'use-debounce'
import { setActiveFilterName } from "../../features/filterSlice";
import { fetchWithDefaults } from "../../config/fetchDefault";
import { setDoNotContactState } from "../../features/doNotContactSlice";
import { clearSelectedOption , toggleSelectedOption } from "../../features/leadFilterSlice";

import LeadTable from "../leadTableFiltering/leadTable";

function QuilityParentBlock({expandSession, jumpIntoQueue, setLeadCard, textingNumbers, unixTommddyyyy, filteredOptions, setRefreshQueue, formatDate, handleToggle,isToggled, filterOpen, data, bulkOpen, title, nested, addToQueue, setMyQueue, setHoldingQueue, holdingQueue, myQueue, openLead, blockType }) {
    const dispatch=useDispatch();
    const doNotContact = useSelector((state)=> state.doNotContact)
    const queue=useSelector((state) => state.queue.queue);
    const queueSource=useSelector((state) => state.queue.queueSource)
    const agentId=useSelector((state) => state.agent.userData).agentId;
    const activeFilterName=useSelector((state) => state.filters.activeFilter);
    const [isOpen, setIsOpen] = useState(false);
    const [successTrigger, setSuccessTrigger] = useState(false);
    const [pastLeadsPeriod, setPastLeadsPeriod] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [removeOptions, setRemoveOptions] = useState(false);
    const [selectedLeads, setSelectedLeads] = useState([]);
    const innerWrapperRef = useRef(null);
    const [selectAll, setSelectAll] = useState(false);

    const getHeight = () => {
        if(innerWrapperRef.current && innerWrapperRef.current.clientHeight===0){
            return 0
        }
        if (innerWrapperRef.current) {
            return innerWrapperRef.current.clientHeight;
        }
        return 0;
    };

    const renderInner=(title, index)=>{

        return(<QuilityNestedBlock openLead={openLead} unixTommddyyyy={unixTommddyyyy} handleToggle={handleToggle} isToggled={isToggled} addToQueue={addToQueue} title={title} key={`quilNestedBlock`+index+title} index={index} data={data}/>)
    }
    const handleExpand=()=>{
        setExpanded(!expanded);
    }

    const frontBlock=['My Leads','My Business At a Glance'];
    const grabMoreLeads= async (e)=>{
        const newActiveTimePeriod = e.target.selectedOptions[0]?.label
        const timePeriod=e.target.value;
        const newOptions = selectedOptions.filter(opt => opt.option !== 'timePeriod');
        setPastLeadsPeriod(timePeriod);
        dispatch(clearSelectedOption(newOptions));
        dispatch(toggleSelectedOption({
        option: 'timePeriod',
        search: timePeriod
    }));
        await getTimePeriodLeads(timePeriod)

        if(newActiveTimePeriod){
            dispatch(setActiveFilterName(newActiveTimePeriod))
        }
    }

    const getTimePeriodLeads = async (timePeriod) => {
        try {
            const leadData = await getLeadsByTimePeriod(timePeriod, agentId, dispatch)

            if(leadData.status === false){
                return
            }

            dispatch(setQueue(leadData.queue))
            dispatch(setBackup(leadData.queue))
            dispatch(setWholeQueue(leadData.queue))
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const debounceGetLeads = useDebouncedCallback(async (timePeriod) => {
        // console.log('useDebouncedCallback', isObjectEmpty(queueSource), {queueSource})
        if(isObjectEmpty(queueSource)){
            await getTimePeriodLeads(timePeriod)
        } else {
            const filterOptions = {}

            for (let index = 0; index < selectedOptions.length; index++) {
                const opn = selectedOptions[index];
                const key = opn.option

                if(!filterOptions[key]){
                    filterOptions[key] = []
                }

                filterOptions[key].push(opn.search)
            }

            const response = await fetchWithDefaults( queueSource.endpoint,{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    ...queueSource.body,
                    filterOptions
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const jsonData = await response.json();
            if (jsonData.status === false) {
                dispatch(setQueue([]));
                dispatch(setWholeQueue([]))
            }
            else {
                const {wholeQueue,queue} = jsonData
                dispatch(setQueue(queue ?? []));
                dispatch(setWholeQueue(wholeQueue ?? (queue ?? [])))
            }
        }
    })

    const filterRecent=()=>{
        const filteredLeads = queue.filter((lead) => !isWithin24Hours(lead.last_contacted));
        dispatch(setQueue(filteredLeads));
    }

    const selectedOptions = useSelector(state => state.filterSearch.selectedOptions)
    const optionsHash = useMemo(()=> hashify(JSON.stringify(selectedOptions)), [selectedOptions])
    const [prevHash, setPrevHash] = useState(optionsHash)

    useEffect(()=>{
        const updatedTimePeriod = leadTimePeriodsFilterOptions.find(o => o.name === activeFilterName)

        if(updatedTimePeriod){
            setPastLeadsPeriod(updatedTimePeriod.value)
            dispatch(setQueueSource({}))

            if(debounceGetLeads.isPending()){
                debounceGetLeads.cancel()
            }

            debounceGetLeads(updatedTimePeriod.value)
        }
    }, [activeFilterName])

    useEffect(()=>{
        if(blockType !== quilityParentBlockType.LEADS){
            return
        }

        //only update if contents of selectedOptions has actually changed...
        if(optionsHash != prevHash){
            if(debounceGetLeads.isPending()){
                debounceGetLeads.cancel()
            }

            console.log('selectedOptions', isObjectEmpty(queueSource), {queueSource})
            debounceGetLeads(pastLeadsPeriod)
            setPrevHash(optionsHash)
        }
    }, [selectedOptions])

    return (
        <span className={`${frontBlock.includes(title) ? 'frontPageQuilityParentBlockWrapper' : 'frontPageQuilityParentBlockWrapper'} ${expanded ? 'expanded' : ''}`} style={{ height: isOpen && getHeight() !==0 ? getHeight()+90 : 'calc(100% - 50px)'}} >
            <SuccessAlert message={'Bulk Actions Applied'} setSuccessTrigger={setSuccessTrigger} successTrigger={successTrigger}/>

            {blockType === quilityParentBlockType.LEADS ? (
                <>
                    <div className="quilityParentBlockHeader">
                        <div className="quilityParentBlockTitle " style={{fontSize: '18px'}}>My Leads</div>
                    </div>
                    <div className="quilityParentBlockContent">
                        {doNotContact.doNotContactState && <div className='dncMsgUpdate' style={{ background: '#ECFDF3', border: '1px solid #17B26A' }}>
                            <svg className='dncIcon' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M20 6L9 17L4 12" stroke="#17B26A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <span className='dncMsgUpdateText' style={{ color: '#17B26A' }}>
                                Your lead has been marked DNC and has been removed from your account.
                            </span>
                            <svg className='dncIcon' style={{ marginLeft: 'auto', cursor: 'pointer' }} onClick={() => dispatch(setDoNotContactState(false))} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6L18 18" stroke="#17B26A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>}
                        <LeadTable
                            expandSession={expandSession}
                            setRefreshQueue={setRefreshQueue}
                            jumpIntoQueue={jumpIntoQueue}
                            textingNumbers={textingNumbers}
                            setLeadCard={setLeadCard}
                        />
                    </div>
                </>
            ) : (
                <>
                    <div className="quilityParentBlockHeader">
                        <div className="quilityParentBlockTitle " style={{fontSize: '18px'}}>{title} { title==='My Leads' && (<span className="leadCount">{myQueue.length} leads</span>)}</div>

                        {title==='My Queue' ? <span className="quilityBlockIcon" onClick={(e) => {e.stopPropagation();handleExpand();}}></span> : ''}
                    </div>
                    <div className="quilityParentBlockContent"  ref={innerWrapperRef}>
                        {nested.length > 0 && (
                            nested.map((item, index) => (
                                renderInner(item,index)
                            ))
                        )}
                        {/* {title==='My Leads' && (
                            <span style={{marginTop:'20px'}}>
                                <div className="filterName">
                                    {activeFilterName==='Last 90 Days' ? (
                                        <>
                                            <div>Leads From</div>
                                            <select
                                                value={pastLeadsPeriod}
                                                className="outlineButton filterButton"
                                                style={{width:'50%'}}
                                                onChange={(e)=>grabMoreLeads(e)}
                                            >
                                                {leadTimePeriodsFilterOptions.map((option, index) => (
                                                    <option key={`lead_time_period_${index}`} value={option.value}>{option.name}</option>
                                                ))}
                                            </select>
                                        </>
                                    ) : (
                                        activeFilterName
                                    )}
                                </div>
                                <FilteringOptions activeFilterName={activeFilterName} jumpIntoQueue={jumpIntoQueue} filteredOptions={filteredOptions} myQueue={queue} setMyQueue={setMyQueue} removeOptions={removeOptions} setHoldingQueue={setHoldingQueue} filterOpen={filterOpen}/>
                                {activeFilterName==='Last 90 Days' && (
                                    <div className="filterOutWrapper">
                                        <div className="jumpIntoButton solidQuilityActiveButton" onClick={()=>filterRecent()}>Filter Recently Called</div>
                                    </div>
                                )}
                                <div className="filterOuterWrapper">
                                    <LeadsQueue selectAll={selectAll} setSelectAll={setSelectAll} setLeadCard={setLeadCard} formatDate={formatDate} setSelectedLeads={setSelectedLeads} selectedLeads={selectedLeads} bulkOpen={bulkOpen} expanded={expanded} setMyQueue={setMyQueue} data={myQueue} title='My Queue' openLead={openLead} />
                                </div>
                                <div style={{margin:'15px'}}>
                                    <BulkActionFooter setSelectAll={setSelectAll} setRefreshQueue={setRefreshQueue} jumpIntoQueue={jumpIntoQueue} textingNumbers={textingNumbers} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} size="small" timePeriod={pastLeadsPeriod}/>
                                </div>
                            </span>
                        )} */}
                    </div>
                </>
            )}

        </span>
    );
}

export default QuilityParentBlock;

